<template>
  <div class="site-contact">
    <ModalSuccessSiteContact v-show="showModalSuccessSiteContact" :show="showModalSuccessSiteContact" @close="showModalSuccessSiteContact = !showModalSuccessSiteContact"></ModalSuccessSiteContact>
    <HeaderMain></HeaderMain>
    <div class="container container-padding">
      <h1 class="heading-top">Kontakta oss</h1>
    </div>
    <main class="wrapper">
      <div class="container">
        <div class="page">
          <p class="page-paragraph">Vill du komma i kontakt med oss kan du skicka ett meddelande via formuläret så svarar vi så fort som möjligt. Vi uppskattar alltid synpunkter på tjänsten.</p>
          <div class="form-alert" v-show="Object.keys(errors).length">
            <span class="alert alert-error">
              <i class="fas fa-times"></i>Fel upptäcktes! Kontrollera de rödmarkerade fälten och försök igen.
            </span>
          </div>
          <form class="form-main" novalidate @submit.prevent="validate()">
            <fieldset class="fieldset-reset form-main-fieldset">
              <div class="form-main-label">
                <label for="name">Namn</label>
                <span class="form-main-label-error" v-show="errors.name">{{ errors.name }}</span>
              </div>
              <div class="form-main-input">
                <input type="text" id="name" maxlength="50" :class="{ error: errors.name }" v-model.trim="form.name">
              </div>
              <div class="form-main-label">
                <label for="email">Epost</label>
                <span class="form-main-label-error" v-show="errors.email">{{ errors.email }}</span>
              </div>
              <div class="form-main-input">
                <input type="email" id="email" maxlength="100" autocorrect="off" autocapitalize="off" :class="{ error: errors.email }" v-model.trim="form.email">
              </div>
              <div class="form-main-label">
                <label for="subject">Ämne</label>
                <span class="form-main-label-error" v-show="errors.subject">{{ errors.subject }}</span>
              </div>
              <div class="form-main-input">
                <input type="text" id="subject" maxlength="50" :class="{ error: errors.subject }" v-model.trim="form.subject">
              </div>
              <div class="form-main-label">
                <label for="message">Meddelande</label>
                <span class="form-main-label-error" v-show="errors.message">{{ errors.message }}</span>
              </div>
              <div class="form-main-input">
                <textarea id="message" rows="5" maxlength="3000" :class="{ error: errors.message }" v-model.trim="form.message"></textarea>
              </div>
            </fieldset>
            <fieldset class="fieldset-reset form-main-fieldset">
              <button class="button-reset button-base button-primary form-main-submit-button" type="submit" :class="{ 'button-primary-active': posting }" :disabled="posting">
                <i class="fas fa-paper-plane"></i><i v-if="posting">Ett ögonblick...</i><span v-else>Skicka meddelande</span>
              </button>
            </fieldset>
          </form>
        </div>
      </div>
    </main>
    <FooterMain></FooterMain>
  </div>
</template>

<script>
import axios from 'axios'
import HeaderMain from '@/components/HeaderMain.vue'
import FooterMain from '@/components/FooterMain.vue'
import ModalSuccessSiteContact from '@/components/modals/SuccessSiteContact.vue'
import { minLength, validEmail } from '@/library/form-validators.js'

export default {
  name: 'SiteContact',
  components: {
    HeaderMain,
    FooterMain,
    ModalSuccessSiteContact
  },
  data () {
    return {
      showModalSuccessSiteContact: false,
      posting: false,
      errors: {},
      form: {
        name: '',
        email: '',
        subject: '',
        message: ''
      }
    }
  },
  methods: {
    resetForm () {
      this.form.name = ''
      this.form.email = ''
      this.form.subject = ''
      this.form.message = ''
    },
    validate () {
      if (Object.keys(this.errors).length) {
        this.errors = {}
      }

      if (!minLength(this.form.name, 1)) {
        this.$set(this.errors, 'name', 'Namn saknas')
      }
      if (!minLength(this.form.email, 1)) {
        this.$set(this.errors, 'email', 'Epostadress saknas')
      } else if (!validEmail(this.form.email)) {
        this.$set(this.errors, 'email', 'Epostadressen har ogiltigt format')
      }
      if (!minLength(this.form.subject, 1)) {
        this.$set(this.errors, 'subject', 'Ämne saknas')
      }
      if (!minLength(this.form.message, 1)) {
        this.$set(this.errors, 'message', 'Skriv ett meddelande')
      }

      if (!Object.keys(this.errors).length) {
        this.submit()
      }
    },
    submit () {
      this.posting = true

      axios.post(process.env.VUE_APP_API_ENDPOINT + '/actions/contact', {
        name: this.form.name,
        email: this.form.email,
        subject: this.form.subject,
        message: this.form.message
      })
      .then(() => {
        window.scrollTo(0, 0)
        this.resetForm()
        this.posting = false
        this.showModalSuccessSiteContact = true
      })
      .catch(() => {
        window.scrollTo(0, 0)
        this.$set(this.errors, 'error', 'Ett fel inträffade, meddelandet kunde inte skickas')
        this.posting = false
      })
    }
  },
  watch: {
    'form.name' () {
      if (this.errors.name) {
        this.$delete(this.errors, 'name')
      }
    },
    'form.email' () {
      if (this.errors.email) {
        this.$delete(this.errors, 'email')
      }
    },
    'form.subject' () {
      if (this.errors.subject) {
        this.$delete(this.errors, 'subject')
      }
    },
    'form.message' () {
      if (this.errors.message) {
        this.$delete(this.errors, 'message')
      }
    }
  },
  mounted () {
    document.title = 'Gluo - Kontakta oss'
  }
}
</script>

<style lang="scss" scoped>
.form-alert {
  margin-top: 16px;
}
</style>
